/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PianoAssenzeDTO,
  PianoAssenzeMensile,
  ProblemDetails,
} from '../models/index';
import {
    PianoAssenzeDTOFromJSON,
    PianoAssenzeDTOToJSON,
    PianoAssenzeMensileFromJSON,
    PianoAssenzeMensileToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/index';

export interface GetPianoAssenzeRequest {
    data?: Date;
    numeroMese?: number;
}

export interface GetPianoAssenzeV2Request {
    data?: Date;
    numeroMese?: number;
}

/**
 * 
 */
export class PianoAssenzeApi extends runtime.BaseAPI {

    /**
     */
    async getPianoAssenzeRaw(requestParameters: GetPianoAssenzeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PianoAssenzeMensile>>> {
        const queryParameters: any = {};

        if (requestParameters['data'] != null) {
            queryParameters['data'] = (requestParameters['data'] as any).toISOString();
        }

        if (requestParameters['numeroMese'] != null) {
            queryParameters['numeroMese'] = requestParameters['numeroMese'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/PianoAssenze`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PianoAssenzeMensileFromJSON));
    }

    /**
     */
    async getPianoAssenze(requestParameters: GetPianoAssenzeRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PianoAssenzeMensile>> {
        const response = await this.getPianoAssenzeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPianoAssenzeV2Raw(requestParameters: GetPianoAssenzeV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PianoAssenzeDTO>>> {
        const queryParameters: any = {};

        if (requestParameters['data'] != null) {
            queryParameters['data'] = (requestParameters['data'] as any).toISOString();
        }

        if (requestParameters['numeroMese'] != null) {
            queryParameters['numeroMese'] = requestParameters['numeroMese'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/PianoAssenze/GetPianoAssenzeV2`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PianoAssenzeDTOFromJSON));
    }

    /**
     */
    async getPianoAssenzeV2(requestParameters: GetPianoAssenzeV2Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PianoAssenzeDTO>> {
        const response = await this.getPianoAssenzeV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

}
